const stopWords = new Set([
  'a', 'about', 'all', 'an', 'and', 'are', 'at', 'by', 'can', 'did', 'do', 'does',
  'for', 'from', 'give', 'how', 'i', 'in', 'is', 'me', 'my', 'of', 'on', 'or',
  'please', 'show', 'tell', 'the', 'there', 'these', 'this', 'to', 'transaction',
  'transactions', 'was', 'were', 'what', 'when', 'where', 'which', 'who', 'with',
  'would', 'you', 'your', 'spend', 'spent', 'spending', 'expense', 'expenses',
  'income', 'earned', 'earn', 'deposit', 'deposits', 'withdrawal', 'withdrawals',
  'debit', 'debits', 'purchase', 'purchases', 'find', 'list', 'total', 'much',
  'many', 'count', 'money', 'amount', 'paid', 'pay', 'largest', 'biggest', 'highest',
  'smallest', 'lowest', 'most', 'least', 'top', 'expensive', 'expensively', 'over', 'above', 'more', 'than', 'greater',
  'under', 'below', 'less', 'between', 'after', 'before', 'since', 'last', 'year',
  'month', 'current', 'recent', 'during', 'into', 'card', 'account', 'bank',
  'category', 'payee', 'tag', 'tags', 'buy', 'bought', 'merchant', 'merchants',
  'monthly', 'yearly', 'daily', 'weekly', 'summary', 'summaries', 'breakdown'
]);

const monthNames = [
  'january', 'february', 'march', 'april', 'may', 'june',
  'july', 'august', 'september', 'october', 'november', 'december'
];

function startOfMonth(year, month) {
  return new Date(year, month, 1);
}

function subtractPeriod(date, amount, unit) {
  const result = new Date(date);
  if (unit.startsWith('year')) {
    const day = result.getDate();
    result.setDate(1);
    result.setFullYear(result.getFullYear() - amount);
    const lastDayOfMonth = new Date(result.getFullYear(), result.getMonth() + 1, 0).getDate();
    result.setDate(Math.min(day, lastDayOfMonth));
  } else if (unit.startsWith('month')) {
    const day = result.getDate();
    result.setDate(1);
    result.setMonth(result.getMonth() - amount);
    const lastDayOfMonth = new Date(result.getFullYear(), result.getMonth() + 1, 0).getDate();
    result.setDate(Math.min(day, lastDayOfMonth));
  } else if (unit.startsWith('week')) {
    result.setDate(result.getDate() - (amount * 7));
  } else {
    result.setDate(result.getDate() - amount);
  }
  return result;
}

function toDateKey(value) {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    return value.slice(0, 10);
  }
  const valueDate = value instanceof Date ? value : new Date(value);
  return `${valueDate.getFullYear()}-${String(valueDate.getMonth() + 1).padStart(2, '0')}-${String(valueDate.getDate()).padStart(2, '0')}`;
}

function getDateFilter(question, now = new Date()) {
  const query = question.toLowerCase();
  let start;
  let end;
  let matchedText = '';

  const betweenMatch = query.match(/\bbetween\s+(\d{4}-\d{2}-\d{2})\s+and\s+(\d{4}-\d{2}-\d{2})\b/);
  const sinceMatch = query.match(/\b(?:since|after)\s+(\d{4}-\d{2}-\d{2})\b/);
  const beforeMatch = query.match(/\bbefore\s+(\d{4}-\d{2}-\d{2})\b/);
  const relativePeriodMatch = query.match(/\b(?:past|last|previous)\s+(\d+)\s+(days?|weeks?|months?|years?)\b/);
  if (relativePeriodMatch) {
    start = subtractPeriod(now, Number(relativePeriodMatch[1]), relativePeriodMatch[2]);
    end = new Date(now);
    end.setDate(end.getDate() + 1);
    matchedText = relativePeriodMatch[0];
  } else if (betweenMatch) {
    start = new Date(`${betweenMatch[1]}T00:00:00`);
    end = new Date(`${betweenMatch[2]}T00:00:00`);
    end.setDate(end.getDate() + 1);
    matchedText = betweenMatch[0];
  } else if (sinceMatch) {
    start = new Date(`${sinceMatch[1]}T00:00:00`);
    matchedText = sinceMatch[0];
  } else if (beforeMatch) {
    end = new Date(`${beforeMatch[1]}T00:00:00`);
    matchedText = beforeMatch[0];
  } else if (/\blast month\b/.test(query)) {
    start = startOfMonth(now.getFullYear(), now.getMonth() - 1);
    end = startOfMonth(now.getFullYear(), now.getMonth());
    matchedText = 'last month';
  } else if (/\bthis month\b|\bcurrent month\b/.test(query)) {
    start = startOfMonth(now.getFullYear(), now.getMonth());
    end = startOfMonth(now.getFullYear(), now.getMonth() + 1);
    matchedText = query.match(/\b(?:this|current) month\b/)[0];
  } else if (/\blast year\b/.test(query)) {
    start = new Date(now.getFullYear() - 1, 0, 1);
    end = new Date(now.getFullYear(), 0, 1);
    matchedText = 'last year';
  } else if (/\bthis year\b|\bcurrent year\b/.test(query)) {
    start = new Date(now.getFullYear(), 0, 1);
    end = new Date(now.getFullYear() + 1, 0, 1);
    matchedText = query.match(/\b(?:this|current) year\b/)[0];
  } else {
    const namedMonth = query.match(/\b(january|february|march|april|may|june|july|august|september|october|november|december)(?:\s+(20\d{2}))?\b/);
    const year = query.match(/\b(19\d{2}|20\d{2})\b/);
    if (namedMonth) {
      const month = monthNames.indexOf(namedMonth[1]);
      const selectedYear = namedMonth[2] ? Number(namedMonth[2]) : year ? Number(year[1]) : now.getFullYear();
      start = startOfMonth(selectedYear, month);
      end = startOfMonth(selectedYear, month + 1);
      matchedText = namedMonth[0];
    } else if (year) {
      const selectedYear = Number(year[1]);
      start = new Date(selectedYear, 0, 1);
      end = new Date(selectedYear + 1, 0, 1);
      matchedText = year[0];
    }
  }

  return {
    start: start ? toDateKey(start) : '',
    end: end ? toDateKey(end) : '',
    matchedText
  };
}

function getAmountFilter(question) {
  const query = question.toLowerCase();
  const greaterMatch = query.match(/\b(?:over|above|more than|greater than)\s+\$?([\d,]+(?:\.\d{1,2})?)/);
  const lessMatch = query.match(/\b(?:under|below|less than)\s+\$?([\d,]+(?:\.\d{1,2})?)/);
  const amountText = greaterMatch ? greaterMatch[1] : lessMatch ? lessMatch[1] : '';
  return {
    minimum: greaterMatch ? Number(amountText.replace(/,/g, '')) : undefined,
    maximum: lessMatch ? Number(amountText.replace(/,/g, '')) : undefined,
    matchedText: greaterMatch ? greaterMatch[0] : lessMatch ? lessMatch[0] : ''
  };
}

function getRankLimit(question) {
  const numberWords = {
    one: 1, two: 2, three: 3, four: 4, five: 5,
    six: 6, seven: 7, eight: 8, nine: 9, ten: 10
  };
  const topMatch = question.match(/\btop\s+(\d+|one|two|three|four|five|six|seven|eight|nine|ten)\b/i);
  if (topMatch) {
    const requestedCount = Number(topMatch[1]) || numberWords[topMatch[1].toLowerCase()];
    return Number.isFinite(requestedCount) && requestedCount > 0
      ? Math.min(requestedCount, 100)
      : undefined;
  }
  if (/\b(?:most expensive|largest|biggest|highest)\b/i.test(question)) return 1;
  return undefined;
}

function getSingularForm(word) {
  if (word.length <= 3 || !word.endsWith('s')) return '';
  if (word.endsWith('ies') && word.length > 4) return `${word.slice(0, -3)}y`;
  if (/(ches|shes|sses|xes|zes)$/.test(word)) return word.slice(0, -2);
  return word.slice(0, -1);
}

function matchesExactPhrase(text, phrase) {
  const words = phrase
    .toLowerCase()
    .match(/[\p{L}\p{N}]+/gu);
  if (!words || words.length === 0) return true;
  const phrasePattern = words
    .map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .join('[^\\p{L}\\p{N}]+');
  return new RegExp(`(?:^|[^\\p{L}\\p{N}])${phrasePattern}(?=$|[^\\p{L}\\p{N}])`, 'iu').test(text);
}

export function answerTransactionQuestion(transactions, question, now = new Date()) {
  const normalizedQuestion = question.trim().toLowerCase();
  const quotedPhrases = Array.from(normalizedQuestion.matchAll(/"([^"]+)"/g), (match) => match[1]);
  const dateFilter = getDateFilter(normalizedQuestion, now);
  const amountFilter = getAmountFilter(normalizedQuestion);
  const rankLimit = getRankLimit(normalizedQuestion);
  const expensesOnly = /\b(?:expense|expenses|spend|spent|spending|debit|debits|withdrawal|withdrawals|purchase|purchases|expensive)\b/.test(normalizedQuestion);
  const incomeOnly = /\b(?:income|earned|earn|deposit|deposits)\b/.test(normalizedQuestion);
  const sortByAmount = rankLimit !== undefined || /\b(?:smallest|lowest|least expensive)\b/.test(normalizedQuestion);
  const descendingAmount = !/\b(?:smallest|lowest|least expensive)\b/.test(normalizedQuestion);
  const queryTerms = normalizedQuestion
    .replace(/"[^"]*"/g, ' ')
    .replace(dateFilter.matchedText, ' ')
    .replace(amountFilter.matchedText, ' ')
    .replace(/\$?[\d,]+(?:\.\d{1,2})?/g, ' ')
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .split(/\s+/)
    .filter(Boolean);
  const searchGroups = queryTerms
    .reduce((groups, term) => {
      if (term === 'and') {
        groups.push([]);
      } else if (!stopWords.has(term)) {
        groups[groups.length - 1].push(term);
      }
      return groups;
    }, [[]])
    .filter((group) => group.length > 0);

  const matchingTransactions = (transactions || []).filter((transaction) => {
    const amount = Number(transaction.amount || 0);
    const transactionDate = toDateKey(transaction.date);
    const searchableText = [
      transaction.payee, transaction.category, transaction.tags,
      transaction.accountName, transaction.bankName
    ].filter(Boolean).join(' ').toLowerCase();

    if (searchGroups.length > 0 && !searchGroups.some((group) => group.every((token) => {
      const singular = getSingularForm(token);
      return searchableText.includes(token) || (singular && searchableText.includes(singular));
    }))) return false;
    if (quotedPhrases.some((phrase) => !matchesExactPhrase(searchableText, phrase))) return false;
    if (dateFilter.start && (!transactionDate || transactionDate < dateFilter.start)) return false;
    if (dateFilter.end && (!transactionDate || transactionDate >= dateFilter.end)) return false;
    if (expensesOnly && amount >= 0) return false;
    if (incomeOnly && amount <= 0) return false;
    if (amountFilter.minimum !== undefined && Math.abs(amount) <= amountFilter.minimum) return false;
    if (amountFilter.maximum !== undefined && Math.abs(amount) >= amountFilter.maximum) return false;
    return true;
  });

  matchingTransactions.sort((left, right) => {
    if (sortByAmount) {
      return descendingAmount
        ? Math.abs(Number(right.amount || 0)) - Math.abs(Number(left.amount || 0))
        : Math.abs(Number(left.amount || 0)) - Math.abs(Number(right.amount || 0));
    }
    return new Date(right.date || 0) - new Date(left.date || 0);
  });

  const income = matchingTransactions.reduce((sum, transaction) => {
    const amount = Number(transaction.amount || 0);
    return amount > 0 ? sum + amount : sum;
  }, 0);
  const expenses = matchingTransactions.reduce((sum, transaction) => {
    const amount = Number(transaction.amount || 0);
    return amount < 0 ? sum + Math.abs(amount) : sum;
  }, 0);
  const rankedTransactions = rankLimit === undefined
    ? matchingTransactions
    : matchingTransactions.slice(0, rankLimit);

  return {
    transactions: rankedTransactions,
    count: matchingTransactions.length,
    isLimited: rankedTransactions.length < matchingTransactions.length,
    resultLimit: rankLimit,
    income,
    expenses,
    net: income - expenses
  };
}
